import { CSSProperties } from "react";
import { Checkbox } from "antd";
import type { CheckboxProps } from "antd";

export type UICheckboxProps = Omit<CheckboxProps, "onChange"> & {
  sx?: Record<string, unknown>;
  noWrapper?: boolean;
  onChange?: (event: { target: { checked: boolean } }) => void;
};

export const UICheckbox = ({
  sx,
  style,
  noWrapper,
  onChange,
  ...props
}: UICheckboxProps) => {
  const sxStyle = (sx ?? {}) as CSSProperties;

  if (noWrapper) {
    return (
      <input
        type="checkbox"
        style={{ ...sxStyle, ...style }}
        onChange={(event) => onChange?.({ target: { checked: event.target.checked } })}
        {...(props as any)}
      />
    );
  }

  return (
    <Checkbox
      style={{ ...sxStyle, ...style }}
      onChange={(event) => onChange?.({ target: { checked: event.target.checked } })}
      {...props}
    />
  );
};
